import Text from "./text";
import Data from "./data";

export default function Dyanmic(props) {
  if (props.params.type === "Text" && !props.params.list) {
    return <Text {...props} />;
  }

  return <Data {...props} />;
}
